import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Stack, Typography } from "@mui/material";
import { t } from "i18next";

const AuthBackButton = ({ handleClick }) => {
  return (
    <Stack
      position={"absolute"}
      top={20}
      left={30}
      direction={"row"}
      alignItems={"center"}
      sx={{ cursor: "pointer" }}
      padding={0.5}
      bgcolor={"lighGrey"}
      borderRadius={1}
      onClick={handleClick}
    >
      <ArrowBackIosIcon sx={{ color: "text.coolGrey", fontSize: "1.125rem" }} />
      <Typography variant="body1" color={"text.coolGrey"}>
        {t("goBack")}
      </Typography>
    </Stack>
  );
};

export default AuthBackButton;
